<template>
  <b-card :title="$t('lang.label_certificate_certs')" class="text-center">
    <b-row>
      <b-col cols="12" class="fix-card-content">
        <b-img class="img-fluid mb-4" src="images/layout/illu-empty-certificate.png" alt="Certificates"></b-img>
        <b-card-text class="h5 mb-4"> {{ $t("lang.label_certificate_noCert") }}</b-card-text>
        <b-button class="mb-4" variant="primary" size="lg" :to="{ name: 'certificate-create' }">{{ $t("lang.label_certificate_getStarted") }}</b-button>
        <need-inspiration-component />
      </b-col>
    </b-row>
  </b-card>
</template>
<style scoped>
.fix-card-content {
  margin-top: 10%;
  margin-bottom: 10%;
}
</style>

<script>
import NeedInspirationComponent from "../NeedInspirationComponent";
export default {
  name: "GetStarted",
  components: {
    NeedInspirationComponent
  }
};
</script>
